<template>
  <v-container
    class="align-content-start pa-0"
    fill-height
    fluid
  >
    <v-row>
      <v-col
        cols="12"
        lg="4"
      >
        <repricing-speed />
      </v-col>

      <v-col
        cols="12"
        lg="8"
      >
        <net-interest-income-sensitivity />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        lg="4"
      >
        <franchise-strength />
      </v-col>

      <v-col
        cols="12"
        lg="8"
      >
        <margin-spread />
      </v-col>
    </v-row>
  </v-container>
</template>

  <script>
import i18nRouteMeta from '@/mixins/i18n/i18nRouteMeta'
import FranchiseStrength from '@/theme/default/views/banking/rates/blocks/FranchiseStrength.vue'
import MarginSpread from '@/theme/default/views/banking/rates/blocks/MarginSpread.vue'
import NetInterestIncomeSensitivity from '@/theme/default/views/banking/rates/blocks/NetInterestIncomeSensitivity.vue'
import RepricingSpeed from '@/theme/default/views/banking/rates/blocks/RepricingSpeed.vue'

export default {
  name      : 'RatesRegressions',
  components: {
    FranchiseStrength,
    MarginSpread,
    NetInterestIncomeSensitivity,
    RepricingSpeed
  },
  directives: {},
  mixins    : [i18nRouteMeta],
  props     : {
  },
  dataStore: {
  },
  enums: {},
  data () {
    return {}
  },
  computed: {},
  watch   : {},
  created () {},
  beforeMount () {},
  mounted () {},
  beforeUpdate () {},
  updated () {},
  destroyed () {},
  methods : {}
}
  </script>

  <style scoped>
  </style>
